import React, {Component} from 'react';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

import PendientesList from './Pendientes';
import AprobadosList from './Aprobados';

export default class Comunicados extends Component{
    render() {
        return(
            <div className="mb-4 col-12 mt-4">
                <Tabs
                    defaultActiveKey="PENDIENTES"
                    tabBarPosition="top"
                    onChange={this.callback}
                    renderTabBar={() => <ScrollableInkTabBar />}
                    renderTabContent={() => <TabContent />}
                >
                    <TabPane tab="PENDIENTES" key="PENDIENTES">
                        <PendientesList {...this.props} />
                    </TabPane>
                    <TabPane tab="APROBADOS" key="APROBADOS">
                        <AprobadosList {...this.props} />
                    </TabPane>
                </Tabs>
            </div>
        )
    }
}
